import { render } from "./aboutus.vue?vue&type=template&id=1f9c5db1"
import script from "./aboutus.js?vue&type=script&lang=js"
export * from "./aboutus.js?vue&type=script&lang=js"

import "./aboutus.vue?vue&type=style&index=0&id=1f9c5db1&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__